<vi-page [sidenavs]="true" [footer]="true">
  <vi-content body>
    <vi-panel main>
      <div class="content" content>
        <!-- WIP suggested implementation - Datepicker + FormGroup
        TODO: write css module for mat-datepicker
        TODO: get rid of overriding css weight by "id". Make it in a way that doesn't incorporate datepicker css in input css (make input css target only input elements)-->
        <span class="element-entry">
          Datepicker with data + Datepicker empty
          <form [formGroup]="dateFormGroup">
            <mat-form-field id="datepicker1" mat-input-height-large-label>
              <mat-label
                >{{ '+INSTALLATIONS.INSTALLATION.DATE_AND_TIME.DATE' | translate }}
              </mat-label>
              <input
                date-at-datepicker
                formControlName="date"
                matInput
                readonly
                [matDatepicker]="dateDatepicker"
                gtm="onSet"
                gtmAction="XXX"
                gtmCategory="YYY"
                fieldTextContentTooltip
              />
              <mat-datepicker-toggle matIconSuffix [for]="dateDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #dateDatepicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field id="datepicker2" mat-input-height-large-label>
              <mat-label
                >{{ '+INSTALLATIONS.INSTALLATION.DATE_AND_TIME.DATE' | translate }}
              </mat-label>
              <input
                date-at-datepicker
                formControlName="empty"
                matInput
                readonly
                [matDatepicker]="dateDatepicker2"
                gtm="onSet"
                gtmAction="XXX"
                gtmCategory="YYY"
                fieldTextContentTooltip
              />
              <mat-datepicker-toggle matIconSuffix [for]="dateDatepicker2"></mat-datepicker-toggle>
              <mat-datepicker #dateDatepicker2></mat-datepicker>
            </mat-form-field>
          </form>
        </span>
      </div>
    </vi-panel>
  </vi-content>
</vi-page>
